import React, { useEffect, useRef, useState } from 'react'
import HeadBar from './dashboard/HeadBar'
import DashboardSpace from '../../../components/DashboardSpace'
import Modal from '../../../components/Modal'
import NewWidget from './dashboard/NewWidget'
import { WidgetProvider } from '../../../providers/WidgetContext'
import { DashboardProvider } from '../../../providers/DashboardContext'
import html2canvas from "html2canvas";
import { useAppContext } from '../../../providers/AppContext'

export default function DashboardSection() {
  const [showNewWidget, setShowNewWidget] = useState(false);
  const {addToast} = useAppContext();
  const toggleNewWidgetModal = (event) => {
    setShowNewWidget(prev => !prev);
  }
  
  const mainContainerRef = useRef(null);

  const toggleFullScreen = () => {
    const el = mainContainerRef.current;
    if (!el) {
      console.warn("El contenedor principal aún no está disponible.");
      return;
    }

    if (!document.fullscreenElement) {
      el.requestFullscreen().catch((err) => {
        console.error("Error al entrar en pantalla completa:", err);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const captureScreenshot = async () => {
    const el = mainContainerRef.current;
    if (!el) return console.warn("No se encontró el contenedor para capturar.");
    addToast("Iniciando captura de dashboard, espere",1)
    // Guardar posición de scroll actual
    const prevScrollY = window.scrollY;

    // 🔹 Aumentar temporalmente el alto del contenedor
    const originalHeight = el.style.height;
    el.style.height = el.scrollHeight + "px";

    
    // 🔹 Capturar todo el contenido
    const canvas = await html2canvas(el, {
      useCORS: true,
      scale: 2,
      scrollY: -window.scrollY, // corrige desplazamiento
      backgroundColor: "#f3f3f3",
      windowWidth: el.scrollWidth,
      windowHeight: el.scrollHeight, // <- captura todo el alto del div
    });

    // Restaurar altura y scroll
    el.style.height = originalHeight;
    window.scrollTo(0, prevScrollY);

    // Convertir a JPG
    const dataURL = canvas.toDataURL("image/jpeg", 0.9);

    // Descargar
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = `dashboard-full-${Date.now()}.jpg`;
    link.click();
    addToast("Descarga finalizada",0)
  };

  return (
    <DashboardProvider space='process'>
      <WidgetProvider>
        <div className='w-full h-full overflow-y-scroll bg-graysens' ref={mainContainerRef}>
          {/* Modal de edicion */}
          <Modal
            isOpen={showNewWidget}
            onClose={() => {
              setShowNewWidget(false);
            }}
            title={
              "Añadir nuevo Widget"
            }
            customType={2}
            colorTitle='bg-bluesens'
            size='w-fit'
          >
            <NewWidget  toggleNewWidgetModal={toggleNewWidgetModal} />
          </Modal>

          <HeadBar  
            toggleNewWidgetModal={toggleNewWidgetModal} 
            onToggleFullscreen={toggleFullScreen}
            onCaptureScreenshot={captureScreenshot}
          />
          <div className='pt-3'>
            <DashboardSpace  />
          </div>
          
        </div>
      </WidgetProvider> 
    </DashboardProvider>
     
  )
}
